<template>
  <protected-pages-layout>
  <div>
    <div
      v-if="!pageReady"
      class="d-flex justify-content-center align-items-center m-5"
    >
      <div
        class="spinner-border text-dark"
        style="width: 7.5rem; height: 7.5rem"
        outputo="status"
      >
        <span class="visually-hidden" outputo="status">Loading...</span>
      </div>
    </div>
    <div class="wrapper" v-else>
      <customHeader
        v-if="loaded"
        :title="title"
        :page="user.Name"
      ></customHeader>
      <div class="d-flex flex-row bd-highlight mb-3" v-if="lead">
        <div class="p-2 bd-highlight">
          <button class="btn btn-outline-primary" @click="redirect()">
            Lead Report
          </button>
        </div>
      </div>
      <div class="row" style="margin: 30px 0">
        <div class="col-md-10 offset-md-1">
          <form>
            <div class="row">
              <div class="col">
                <label>Report Type</label>
                <select
                  v-model="parameters.personalReportType"
                  class="form-select"
                  @change="getReport()"
                >
                  <option
                    :key="index"
                    :value="reportType.value"
                    v-for="(reportType, index) in personalReportTypes"
                  >
                    {{ reportType.name }}
                  </option>
                </select>
              </div>
              <div
                class="col"
                v-if="parameters.personalReportType === 'client'"
              >
                <label>Favorites Page</label>
                <select
                  v-model="parameters.offset"
                  class="form-select"
                  @change="getReport()"
                >
                  <option
                    :key="index"
                    :value="page"
                    v-for="(page, index) in favoritesPages"
                  >
                    {{ page }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label>Period</label>
                <select
                  v-model="parameters.period"
                  class="form-select"
                  @change="getReport()"
                >
                  <option
                    :key="index"
                    :value="period.value"
                    v-for="(period, index) in periods"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
              <div
                class="col"
                v-if="parameters.personalReportType !== 'client'"
              >
                <label>Breakdown</label>
                <select
                  v-model="parameters.breakdown"
                  class="form-select"
                  @change="getReport()"
                >
                  <option
                    :key="index"
                    :value="breakdown.value"
                    v-for="(breakdown, index) in breakdowns"
                  >
                    {{ breakdown.name }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>

        <div class="d-flex justify-content-center">
          <div class="col-md-3">
            <div class="card border-0 shadow card-dashboard">
              <div
                class="card-body"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                v-on:click="calculateTotals()"
              >
                <h6 class="card-subtitle mb-2 text-muted">Total</h6>
                <h3 class="card-title" v-if="total">{{ total }}</h3>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="card" id="card-chart" v-if="!empty">
                <barChart :data="chartData" :key="barChartKey"></barChart>
              </div>
              <div class="card" id="card-chart" v-else>
                <h3 class="card-title">No Data to display</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-outline-primary" @click="csvExport(chart)">
            Download chart data
          </button>
        </div>
      </div>

      <div class="admin-content">
        <div class="left-side">
          <div class="col">
            <div class="row">
              <div class="clients-dashboard-dl">
                <div class="card border-0 shadow card-dashboard p-2">
                  <h3 class="card-title">Get Clients Dashboard</h3>
                  <div class="card-body" v-if="clientsDashboardIsLoaded">
                    <button
                      class="btn btn-outline-primary"
                      @click="clientsDashbordCSVExport()"
                    >
                      Download Clients Dashboard
                    </button>
                  </div>
                  <div class="card-body" v-else>
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      disabled
                    >
                      <span
                        class="spinner-grow spinner-grow-sm"
                        outputo="status"
                        aria-hidden="true"
                      ></span>
                      Loading clients dashboard...
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="clients-dashboard-dl">
                  <div class="card border-0 shadow card-dashboard p-2">
                    <h3 class="card-title">Raw Data Export</h3>
                    <div class="card-body" v-if="isEntriesRawDataLoaded">
                      <select
                        v-model="dateForRawExtract"
                        placeholder="project"
                        class="form-select form-input"
                      >
                        <option
                          :key="index"
                          :value="date.Format"
                          v-for="(date, index) in availableDates"
                        >
                          {{ date.FormatType }}
                        </option>
                      </select>
                      <button
                        class="btn btn-outline-primary mt-5"
                        @click="fetchRawEntriesDataWrapper(dateForRawExtract)"
                      >
                        Download Raw Data
                      </button>
                    </div>
                    <div class="card-body" v-else>
                      <button
                        class="btn btn-outline-primary"
                        type="button"
                        disabled
                      >
                        <span
                          class="spinner-grow spinner-grow-sm"
                          outputo="status"
                          aria-hidden="true"
                        ></span>
                        Loading clients dashboard...
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-side" v-if="isUserAdmin">
          <div
            class="p-3 border border-2 border-dark rounded shadow onboard-form"
          >
            <div class="">
              <form action="">
                <h3>ONBOARD USER</h3>
                <div class="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    v-model="newUser.name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <input
                    type="text"
                    v-model="newUser.email"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input
                    type="text"
                    v-model="newUser.password"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>Role</label>
                  <select v-model="newUser.role" class="form-select">
                    <option
                      :key="role"
                      v-bind:value="role"
                      v-for="role in roles"
                    >
                      {{ role }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Country</label>
                  <select v-model="newUser.country" class="form-select">
                    <option
                      :key="country"
                      v-bind:value="country"
                      v-for="country in countries"
                    >
                      {{ country }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>POD</label>
                  <select v-model="newUser.pod" class="form-select">
                    <option :key="pod" v-bind:value="pod" v-for="pod in pods">
                      {{ pod }}
                    </option>
                  </select>
                </div>
                <div class="form-check pt-2">
                  <input
                    type="checkbox"
                    v-model="newUser.isLead"
                    class="form-check-input"
                    id="checkBoxLead"
                  />
                  <label for="checkBoxLead" class="form-check-label"
                    >is Team Lead</label
                  >
                </div>
                <div class="row">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="onboardUser()"
                    v-if="!submittingData"
                  >
                    Submit
                  </button>
                  <button class="btn btn-primary" type="button" disabled v-else>
                    <span
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="alert alert-success alert-dismissible fade show mt-3"
            role="alert"
            v-if="onboardDataSended && userOnboardingSucces"
          >
            <h4 class="alert-heading">User onboarded successfully</h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          <div
            class="alert alert-danger alert-dismissible fade show mt-3"
            role="alert"
            v-else-if="onboardDataSended && !userOnboardingSucces"
          >
            <h4 class="alert-heading">
              :/ We are sorry but the user couldn't be onboarded
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
            <p>Maybe try again later or reach out to Broggl dev team</p>
          </div>
        </div>
        <div class="right-side">
          <div
            class="p-3 border border-2 border-dark rounded shadow onboard-form"
            v-if="isUserAdmin"
          >
            <div>
              <form action="">
                <h3>OFFBOARD USER</h3>
                <div class="form-group pb-2">
                  <label>Email</label>
                  <input
                    type="text"
                    v-model="emailToOffboard"
                    class="form-control"
                  />
                </div>
                <div class="row pt-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="offboardUser()"
                    v-if="!submittingDataOffboard"
                  >
                    Submit
                  </button>
                  <button class="btn btn-primary" type="button" disabled v-else>
                    <span
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </button>
                </div>
              </form>
            </div>
            <div
              class="alert alert-success alert-dismissible fade show mt-3"
              role="alert"
              v-if="offboardDataSended && userOffboardingSucces"
            >
              <h4 class="alert-heading">User offboarded successfully</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
            <div
              class="alert alert-danger alert-dismissible fade show mt-3"
              role="alert"
              v-else-if="offboardDataSended && !userOffboardingSucces"
            >
              <h4 class="alert-heading">
                :/ We are sorry but the user couldn't be offboarded
              </h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
              <p>Maybe try again later or reach out to Broggl dev team</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="productModal"
    tabindex="-1"
    aria-labelledby="productModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-m">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title" id="exampleModalLabel">Totals</h6>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <ul class="list-group">
            <li
              class="list-group-item"
              v-for="(value, key) in totals"
              :key="key"
              style="list-style: none"
            >
              {{ key }}: {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</protected-pages-layout>
</template>

<script setup>
import Navbar from "../components/Navbar.vue";
import PersonnalReport from "../components/personnal-reports.vue";
import Header from "../components/Header.vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "../stores/user.js";
import { useClientStore } from "../stores/client.js";
import { useEntriesStore } from "../stores/entries";
import { ref, reactive, onMounted, computed } from "vue";
import { usePersonalReportStore } from "../stores/personalReport.js";
import {
  periods,
  breakdowns,
  personalReportTypes,
} from "../assets/variables.js";

const personalReportStore = usePersonalReportStore();

const {
  getTotal: total,
  getChart: chart,
  getParameters: parameters,
  getChartData: chartData,
  getBarChartKey: barChartKey,
  getEmpty: empty,
  getTotals: totals,
  getDetail: details,
  getFavoritesPages: favoritesPages,
  getIsLead: lead,
} = storeToRefs(personalReportStore);

const {
  getReport,
  calculateTotals,
  csvExport,
  convertArrayOfObjectsToCSV,
  IsLead,
  redirect,
} = personalReportStore;

const clientStore = useClientStore();

const { clientsDashboardIsLoaded } = storeToRefs(clientStore);

const { clientsDashbordCSVExport } = clientStore;

const entriesStore = useEntriesStore();

const { fetchRawEntriesData } = entriesStore;

let roles = [
  "TSE",
  "CSM",
  "CSe",
  "BA",
  "Support",
  "KAM",
  "PSM",
  "TSM",
  "PS",
  "Null",
];

let countries = [
  "DACH",
  "Spain",
  "Apac",
  "US",
  "International",
  "UK & Nordics",
  "France",
  "Null",
];

let pods = ["AM", "Team Large", "Team Mid", "Team Strategic", "Null"];

const userStore = useUserStore();

const {
  user,
  newUser,
  isUserAdmin,
  userOnboardingSucces,
  onboardDataSended,
  submittingData,
  submittingDataOffboard,
  emailToOffboard,
  userOffboardingSucces,
  offboardDataSended,
} = storeToRefs(userStore);

const { checkIfUserIsAdmin, onboardUser, offboardUser } = userStore;

const pageReady = ref(false);
onMounted(async () => {
  await getReport();
  await IsLead();
  userStore.checkIfUserIsAdmin();
  pageReady.value = true;
});

const dateForRawExtract = ref("");

const availableDates = computed(() => {
  let result = [];
  result.push({
    FormatType: "All Since 2021",
    Format: "2021-01-01",
  });
  let currentYear = new Date().getFullYear();
  let twoYearAgo = currentYear - 2;
  let lastYear = currentYear - 1;
  let firstDate = twoYearAgo + "-07-01";
  let secondDate = lastYear + "-06-30";
  result.push({
    FormatType: "FY " + (twoYearAgo - 2000) + "-" + (lastYear - 2000),
    Format: firstDate + ";" + secondDate,
  });
  let thridDate = lastYear + "-07-01";
  let fourthDate = currentYear + "-06-30";
  result.push({
    FormatType: "FY " + (lastYear - 2000) + "-" + (currentYear - 2000),
    Format: thridDate + ";" + fourthDate,
  });
  let fifthDate = (2000+(currentYear - 1999)) + "-07-01";
  result.push({
    FormatType: "FY " + (currentYear - 2000) + "-" + (currentYear - 1999),
    Format: fourthDate + ";" + fifthDate,
  });
  return result;
});

const isEntriesRawDataLoaded = ref(true);

const fetchRawEntriesDataWrapper = async (date) => {
  isEntriesRawDataLoaded.value = false;
  await fetchRawEntriesData(date);
  isEntriesRawDataLoaded.value = true;
};
</script>

<script>
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import Header from "../components/Header.vue";
import { defineComponent } from "vue";
import { LogarithmicScale } from "chart.js";
export default defineComponent({
  name: "Settings",
  components: {
    navbar: Navbar,
    customHeader: Header,
    barChart,
  },
});
</script>

<style lang="scss">
.wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 100px;
}

.card {
  margin-top: 30px;
}

.group-header {
  color: #6c757d !important;
  font-weight: bolder;
  text-decoration: none;
  margin: 0px 13px;
  list-style-type: none;
  cursor: pointer;
}

.group-header:after {
  content: "";
  display: block;
  /* margin: auto; */
  height: 3px;
  width: 0px;
  background: transparent;
  transition: width 0.2s ease;
}

.group-header:hover:after {
  width: 120px;
  background: #fe938c;
}

h2 {
  text-align: center;
}

.entry-detail {
  text-align: left;
}

.table th {
  border-top: none !important;
}

.table td {
  border-top: none !important;
}

.admin-content {
  @media (min-width: 768px) {
    width: 95%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 2vh;
    margin-bottom: 4vh;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }
}

.clients-dashboard-dl {
  @media (min-width: 50px) {
    height: max-content;
  }
}

.left-side {
  @media (min-width: 50px) {
    width: 100%;
    height: max-content;
    position: relative;
    background-color: inherit;
  }
  @media (min-width: 768px) {
    width: 33.333% !important;
    height: max-content;
    position: relative;
    background-color: inherit;
    margin-right: 2vw;
  }
}

.center-side {
  @media (min-width: 50px) {
    width: 100%;
    height: max-content;
    position: relative;
    background-color: inherit;
  }
  @media (min-width: 768px) {
    width: 33.333% !important;
    height: max-content;
    position: relative;
    background-color: inherit;
    margin-right: 2%;
    margin-left: 2%;
  }
}

.right-side {
  @media (min-width: 50px) {
    width: 100%;
    background-color: inherit;
  }
  @media (min-width: 768px) {
    width: 33.333% !important;
    height: max-content;
    position: relative;
    background-color: inherit;
    margin-left: 2%;
  }
}

.onboard-form {
  @media (min-width: 50px) {
    width: 100%;
  }
}
</style>
